import React from 'react';
import ReactDOM from 'react-dom/client';

import './fonts/Poppins/PoppinsBold.ttf';
import './fonts/Poppins/PoppinsMedium.ttf';
import './fonts/Poppins/PoppinsSemiBold.ttf';
import './fonts/Poppins/PoppinsRegular.ttf';
import './fonts/Roboto/Roboto-Bold.ttf';
import './fonts/Roboto/Roboto-SemiBold.ttf';
import './fonts/Roboto/Roboto-Medium.ttf';
import './fonts/Roboto/Roboto-Regular.ttf';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
